import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
//import { LgvAuth0Service } from '../../core/core.module';
import { LgvAuth0Service } from '../../core/services/lgv-auth0.service';

@Component({
  selector: 'lgv-password-login',
  templateUrl: './password-login.component.html',
  styleUrls: ['./password-login.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class PasswordLoginComponent {
  constructor(private authService: LgvAuth0Service) { }

  ngOnInit(): void {
    // Ensure the secondary Auth0 config is used before triggering the login
    this.authService.UseSecondaryAuthConfig = true;
    localStorage.setItem('UseSecondaryAuthConfig', 'true'); // Add this line
    this.authService.ResetAuth0Tenant();  // Reset to ensure it loads the new config
    this.authService.login(true);
  }

}
